import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "nameInput",
    "nextButton",
    "deploymentsContainer",
    "newDeploymentRow",
    "assignmentSelect",
  ]

  static values = {
    newDeploymentIndex: { type: Number, default: 0 },
    deploymentKeys: Array,
  }

  connect() {
    this.validateNameInputs()
    this.validateAssignments()
  }

  addDeployment(event) {
    event.preventDefault()

    const template = this.newDeploymentRowTarget.content.cloneNode(true)
    const key = `new_${this.newDeploymentIndexValue}`
    this.newDeploymentIndexValue += 1

    const input = template.querySelector("[data-radar-multi-location-migration-target='nameInput']")
    input.name = `deployment_names[${key}]`
    input.id = `deployment_name_${key}`

    const label = template.querySelector("label")
    if (label) {
      label.setAttribute("for", input.id)
    }

    this.deploymentsContainerTarget.appendChild(template)
    this.validateNameInputs()
  }

  removeDeployment(event) {
    event.preventDefault()
    const row = event.currentTarget.closest("[data-radar-multi-location-migration-target='deploymentRow']")
    if (row) {
      row.remove()
      this.validateNameInputs()
    }
  }

  validateNameInputs() {
    if (!this.hasNextButtonTarget || !this.hasNameInputTarget) {
      return
    }

    const allFilled = this.nameInputTargets.every((input) => input.value.trim().length > 0)
    this.nextButtonTarget.disabled = !allFilled
  }

  validateAssignments() {
    if (!this.hasNextButtonTarget || !this.hasDeploymentKeysValue) {
      return
    }

    const assignedKeys = new Set(
      this.assignmentSelectTargets.map((select) => select.value).filter(Boolean),
    )
    const allAssigned = this.deploymentKeysValue.every((key) => assignedKeys.has(key))
    this.nextButtonTarget.disabled = !allAssigned
  }
}
